/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  isSplash: false, // Change this to false if you don't want Splash screen.
};

//SEO Related settings
const seo = {
  title: "Faisal's Portfolio",
  description:
    "A Data Scientist and Finance professional with an entrepreneurial streak. Bringing a diverse knowledge and experience, from Healthcare Management to Investments and Credit Risk.",
  og: {
    title: "Faisal Jina Portfolio",
    type: "website",
    url: "https://faisaljina.github.io",
  },
};

//Home Page
const greeting = {
  title: "Faisal Jina",
  logo_name: "FaisalJina",
  nickname: "( PgDip • MFin • MPharm )",
//  nickname: "( The Data/AI and Finance Guy )",
  subTitle:
    "Data Science meets Business and Healthcare.",
  subTitle2: "Bringing a diverse knowledge and experience from Finance, Investing, Healthcare, Management, and Construction Risk.",
  resumeLink:
    "https://www.linkedin.com/in/faisal-jina/",
  portfolio_repository: "https://github.com/faisaljina?tab=repositories",
};

const socialMediaLinks = [
  /* Your Social Media Link */
  // github: "https://github.com/ashutosh1919",
  // linkedin: "https://www.linkedin.com/in/ashutosh-hathidara-88710b138/",
  // gmail: "ashutoshhathidara98@gmail.com",
  // gitlab: "https://gitlab.com/ashutoshhathidara98",
  // facebook: "https://www.facebook.com/laymanbrother.19/",
  // twitter: "https://twitter.com/ashutosh_1919",
  // instagram: "https://www.instagram.com/layman_brother/"

  {
    name: "LinkedIn",
    link: "https://www.linkedin.com/in/faisal-jina/",
    fontAwesomeIcon: "fa-linkedin-in", // Reference https://fontawesome.com/icons/linkedin-in?style=brands
    backgroundColor: "#0077B5", // Reference https://simpleicons.org/?q=linkedin
  },
  {
    name: "Github",
    link: "https://github.com/faisaljina",
    fontAwesomeIcon: "fa-github", // Reference https://fontawesome.com/icons/github?style=brands
    backgroundColor: "#181717", // Reference https://simpleicons.org/?q=github
  },
  {
    name: "DataCamp",
    link: "https://faisaljina.github.io/datacamp-profile/",
    // fontAwesomeIcon: "simple-icons:datacamp",
    fontAwesomeIcon: "fas fa-graduation-cap",
    backgroundColor: "#03EF62", // Reference https://simpleicons.org/?q=linkedin
  },
  // {
  //   name: "Instagram",
  //   link: "https://www.instagram.com/layman_brother/",
  //   fontAwesomeIcon: "fa-instagram", // Reference https://fontawesome.com/icons/instagram?style=brands
  //   backgroundColor: "#E4405F", // Reference https://simpleicons.org/?q=instagram
  // },
];

const skills = {
  data: [
    {
      title: "Data Science & AI",
      fileName: "DataScienceImg",
      skills: [
        "⚡ Data Wrangling, EDA, Analytics, Feature Engineering, and Visualisation",
        "⚡ Time Series modelling and Financial Quantitative Analysis",
        "⚡ ML modelling, including ElasticNet (LogReg), Random Forests/Gradient Boosting, SVMs, and Naive Bayes",
        "⚡ Natural language processing using transformer models (BERT) and Deep Learning with PyTorch and TensorFlow",
        "⚡ Use of Big data techniques, Package Development, and Dashboarding with R Shiny and Power BI",
      ],
      softwareSkills: [
        // {
        //   skillName: "Keras",
        //   fontAwesomeClassname: "simple-icons:keras",
        //   style: {
        //     backgroundColor: "white",
        //     color: "#D00000",
        //   },
        // },
        {
          skillName: "Python",
          fontAwesomeClassname: "logos-python",
          style: {
            backgroundColor: "transparent",
            color: "#3776AB",
          },
        },
        {
          skillName: "Jupyter",
          fontAwesomeClassname: "logos-jupyter",
          style: {
            backgroundColor: "transparent",
            color: "#3776AB",
          },
        },
        {
          skillName: "Scikit-Learn",
          fontAwesomeClassname: "simple-icons:scikit-learn",
          style: {
            backgroundColor: "transparent",
            color: "#F7931E",
          },
        },
        {
          skillName: "PyTorch",
          fontAwesomeClassname: "logos-pytorch",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Tensorflow",
          fontAwesomeClassname: "logos-tensorflow",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "R Studio",
          fontAwesomeClassname: "fa-brands:r-project",
          style: {
            backgroundColor: "transparent",
            color: "#276DC3",
          },
        },
        {
          skillName: "Power BI",
          fontAwesomeClassname: "simple-icons:powerbi",
          style: {
            backgroundColor: "transparent",
            color: "#F2C811",
          },
        },
      ],
    },
    {
      title: "Qualifications",
      fileName: "FullStackImg",
      skills: [
        "⚡ Postgraduate Diploma in Data and AI (Distinction)",
        "⚡ Masters Degree in Finance (Distinction)",
        "⚡ Level I on the Chartered Financial Analyst programme",
        "⚡ Masters Degree in Pharmacy from University of Bath",
        "⚡ CertHE in Mathematics and Statistics (Distinction)",
        "⚡ PRINCE2 Agile Foundation & Practitioner",
        "⚡ DataCamp: Time Series with R skill track",
      ],
      softwareSkills: [
        {
          skillName: "PgDip Data/AI",
          fontAwesomeClassname: "bx:bx-data", // See https://iconify.design/icon-sets/
          style: {
            color: "#be0f34", // See https://imagecolorpicker.com/en
          },
        },
        {
          skillName: "MSc Finance",
          fontAwesomeClassname: "mdi:finance",
          style: {
            color: "##1e4b9c",
          },
        },
        {
          skillName: "CFA Lev II Candidate",
          fontAwesomeClassname: "carbon:finance",
          style: {
            color: "#009864",
          },
        },
        {
          skillName: "MPharm",
          fontAwesomeClassname: "maki:pharmacy-11",
          style: {
            color: "#002769",
          },
        },
        {
          skillName: "CertHE Maths & Stats",
          fontAwesomeClassname: "ion:stats-chart",
          style: {
            color: "#3994c0",
          },
        },
        {
          skillName: "PRINCE2 Agile Practitioner",
          fontAwesomeClassname: "eos-icons:content-lifecycle-management",
          style: {
            color: "#705f96"
            // backgroundColor: "#03ef62"
          },
        },
        {
          skillName: "Time Series with R",
          fontAwesomeClassname: "simple-icons:datacamp",
          style: {
            color: "#000000"
            // backgroundColor: "#03ef62"
          },
        },
      //   {
      //     skillName: "HTML5",
      //     fontAwesomeClassname: "simple-icons:html5",
      //     style: {
      //       color: "#E34F26",
      //     },
      //   },
      //   {
      //     skillName: "CSS3",
      //     fontAwesomeClassname: "fa-css3",
      //     style: {
      //       color: "#1572B6",
      //     },
      //   },
      //   {
      //     skillName: "Sass",
      //     fontAwesomeClassname: "simple-icons:sass",
      //     style: {
      //       color: "#CC6699",
      //     },
      //   },
      //   {
      //     skillName: "ReactJS",
      //     fontAwesomeClassname: "simple-icons:react",
      //     style: {
      //       color: "#61DAFB",
      //     },
      //   },
      //   {
      //     skillName: "NodeJS",
      //     fontAwesomeClassname: "simple-icons:node-dot-js",
      //     style: {
      //       color: "#339933",
      //     },
      //   },
      //   {
      //     skillName: "NPM",
      //     fontAwesomeClassname: "simple-icons:npm",
      //     style: {
      //       color: "#CB3837",
      //     },
      //   },
      //   {
      //     skillName: "Yarn",
      //     fontAwesomeClassname: "simple-icons:yarn",
      //     style: {
      //       color: "#2C8EBB",
      //     },
      //   },
      //   {
      //     skillName: "Gatsby",
      //     fontAwesomeClassname: "simple-icons:gatsby",
      //     style: {
      //       color: "#663399",
      //     },
      //   },
      //   {
      //     skillName: "Flutter",
      //     fontAwesomeClassname: "simple-icons:flutter",
      //     style: {
      //       color: "#02569B",
      //     },
      //   },
      ],
    },
    // {
    //   title: "Cloud Infra-Architecture",
    //   fileName: "CloudInfraImg",
    //   skills: [
    //     "⚡ Experience working on multiple cloud platforms",
    //     "⚡ Hosting and maintaining websites on virtual machine instances along with integration of databases",
    //     "⚡ Deploying deep learning models on cloud to use on mobile devices",
    //     "⚡ Setting up streaming jobs from DB to Server or vice-versa on GCP and AWS",
    //   ],
    //   softwareSkills: [
    //     {
    //       skillName: "GCP",
    //       fontAwesomeClassname: "simple-icons:googlecloud",
    //       style: {
    //         color: "#4285F4",
    //       },
    //     },
    //     {
    //       skillName: "AWS",
    //       fontAwesomeClassname: "simple-icons:amazonaws",
    //       style: {
    //         color: "#FF9900",
    //       },
    //     },
    //     {
    //       skillName: "Azure",
    //       fontAwesomeClassname: "simple-icons:microsoftazure",
    //       style: {
    //         color: "#0089D6",
    //       },
    //     },
    //     {
    //       skillName: "Firebase",
    //       fontAwesomeClassname: "simple-icons:firebase",
    //       style: {
    //         color: "#FFCA28",
    //       },
    //     },
    //     {
    //       skillName: "PostgreSQL",
    //       fontAwesomeClassname: "simple-icons:postgresql",
    //       style: {
    //         color: "#336791",
    //       },
    //     },
    //     {
    //       skillName: "MongoDB",
    //       fontAwesomeClassname: "simple-icons:mongodb",
    //       style: {
    //         color: "#47A248",
    //       },
    //     },
    //     {
    //       skillName: "Docker",
    //       fontAwesomeClassname: "simple-icons:docker",
    //       style: {
    //         color: "#1488C6",
    //       },
    //     },
    //     {
    //       skillName: "Kubernetes",
    //       fontAwesomeClassname: "simple-icons:kubernetes",
    //       style: {
    //         color: "#326CE5",
    //       },
    //     },
    //   ],
    // },
    {
      title: "Commercial Products",
      fileName: "DesignImg",
      skills: [
        "⚡ GreenPen.co.uk: Combining healthcare data with statutory business accounts, this is an extension of my MSc Finance thesis. Unstructured data and regression analysis were used to build a parsimonious model of Pharmacy valuation. The website implementation gives users an up-to-date valuation estimate for every pharmacy in Great Britain.",
        "⚡ FindAPharmacist.co.uk: One of the first digital Pharmacy locum platforms, this used a bespoke 'bidding' algorithm to find pharmacies the best locums at the cheapest rates. It was fully automated for job posting, locum bidding, invoices, payments, and reviews.",
        "⚡ ShortStock.co.uk: Pharmacies that had ordered excess non-returnable stock, or had expensive items that were approaching expiry, could list them on the website. Other pharmacies could then purchase this stock at a reduced price, with the aim of saving money and reducing medicine wastage."
      ],
      softwareSkills: [
        {
          skillName: "Stata",
          fontAwesomeClassname: "file-icons:stata",
          style: {
            backgroundColor: "transparent",
            color: "#799bb7",
          },
        },
        {
          skillName: "Python",
          fontAwesomeClassname: "logos-python",
          style: {
            backgroundColor: "transparent",
            color: "#3776AB",
          },
        },
        {
          skillName: "PHP",
          fontAwesomeClassname: "fa-brands:php",
          style: {
            backgroundColor: "transparent",
            color: "#6180b6",
          },
        },
        {
          skillName: "MySQL",
          fontAwesomeClassname: "cib:mysql",
          style: {
            backgroundColor: "transparent",
            color: "#4479A1",
          },
        },
        // {
        //   skillName: "jQuery",
        //   fontAwesomeClassname: "bx:bxl-jquery",
        //   style: {
        //     backgroundColor: "transparent",
        //     color: "#0769AD",
        //   },
        // },
        {
          skillName: "Apache",
          fontAwesomeClassname: "cib:apache",
          style: {
            backgroundColor: "transparent",
            color: "#D22128",
          },
        },
        {
          skillName: "JavaScript",
          fontAwesomeClassname: "simple-icons:javascript",
          style: {
            backgroundColor: "#000000",
            color: "#F7DF1E",
          },
        },
        {
          skillName: "WordPress",
          fontAwesomeClassname: "mdi:wordpress",
          style: {
            backgroundColor: "transparent",
            color: "#21759b",
          },
        },
      ],
    },
  ],
};

// Education Page
const competitiveSites = {
  // competitiveSites: [
  //   {
  //     siteName: "HackerRank",
  //     iconifyClassname: "simple-icons:hackerrank",
  //     style: {
  //       color: "#2EC866",
  //     },
  //     profileLink: "https://www.hackerrank.com/layman_brother",
  //   },
  //   {
  //     siteName: "Codechef",
  //     iconifyClassname: "simple-icons:codechef",
  //     style: {
  //       color: "#5B4638",
  //     },
  //     profileLink: "https://www.codechef.com/users/ashutosh_1919",
  //   },
  //   {
  //     siteName: "Codeforces",
  //     iconifyClassname: "simple-icons:codeforces",
  //     style: {
  //       color: "#1F8ACB",
  //     },
  //     profileLink: "http://codeforces.com/profile/layman_brother",
  //   },
  //   {
  //     siteName: "Hackerearth",
  //     iconifyClassname: "simple-icons:hackerearth",
  //     style: {
  //       color: "#323754",
  //     },
  //     profileLink: "https://www.hackerearth.com/@ashutosh391",
  //   },
  //   {
  //     siteName: "Kaggle",
  //     iconifyClassname: "simple-icons:kaggle",
  //     style: {
  //       color: "#20BEFF",
  //     },
  //     profileLink: "https://www.kaggle.com/laymanbrother",
  //   },
  // ],
};

const degrees = {
  // degrees: [
  //   {
  //     title: "Indian Institute of Information Technology Kurnool",
  //     subtitle: "B.Tech. in Computer Engineering",
  //     logo_path: "iiitk_logo.png",
  //     alt_name: "IIITDM Kurnool",
  //     duration: "2016 - Present",
  //     descriptions: [
  //       "⚡ I have studied basic software engineering subjects like DS, Algorithms, DBMS, OS, CA, AI etc.",
  //       "⚡ Apart from this, I have done courses on Deep Learning, Data Science, Cloud Computing and Full Stack Development.",
  //       "⚡ I was selected for Merit cum Means Scholarship which is given to top 10% of students in college. I have received award from respected director for consistently best performance in academics.",
  //     ],
  //     website_link: "http://iiitk.ac.in",
  //   },
  // ],
};

const certifications = {
  // certifications: [
  //   {
  //     title: "Machine Learning",
  //     subtitle: "- Andrew Ng",
  //     logo_path: "stanford_logo.png",
  //     certificate_link:
  //       "https://www.coursera.org/account/accomplishments/verify/22MTSSC5WDTM",
  //     alt_name: "Stanford University",
  //     color_code: "#8C151599",
  //   },
  // ],
};

// Experience Page
const experience = {
  title: "Projects",
  subtitle: "( currently / perpetually under construction )",
  description:
    "Click on the projects below to take a look at some examples of my Data Science work. Please note, this page may not contain my most recent work - please click 'See All Repos' for more!",
  header_image_path: "experience.svg",
  sections: [
    {
      title: "Python Projects",
      experiences: [
        {
          title: "Deep Learning",
          company: "Dataset: Image data (academic set, pre-labelled)",
          company_url: "https://faisaljina.github.io/deep-image-classifier/",
          logo_path: "PyTorch_logo_icon.svg",
          duration: "Features: EDA, Tensors, Deep learning, GPU acceleration",
          location: "Techniques: - PyTorch, Object Oriented Programming, Simple and Convolutional neural networks",
          description:
            "The data was explored, visualised and reshaped. A simple neural network was built, and the loss function and optimizer defined. The SNN was trained, used to predict and measured for accuracy. A convolutional neural network was built and trained. The CNN's predictions were measured for accuracy, showing a good performance increase over the SNN.",
          color: "#000000", //border colour
        },
        {
          title: "Natural Language Processing",
          company: "Dataset: Covid-19 Tweets (Carnegie Mellon University)",
          company_url: "https://faisaljina.github.io/NLP-Twitter-Covid/",
          logo_path: "nltklogo.png",
          duration: "Features: EDA, Visualisation, Stopwords, Feature Engineering, Parts-of-Speech, Sentiment Analysis",
          location: "Techniques: RegEx, POS analysis, VADER, NRCLex, CountVectorizer, TfidfVectorizer, SMOTE-NC, Bayesian & Logit Modelling",
          description:
            "The data was explored, cleaned, and tokenized, removing stopwords and normalising the tweets. Simple metrics were derived using RegEx, before POS-tagging and analysis. Sentiment analysis was then conducted using VADER for affect and NRCLex for emotion. Features were engineered and the data split and oversampled to address class imbalance. The classification modelling used combinations of Count/Tfidf Vectorizer with Naive Bayes/Logistic Regression.",
          color: "#000000", //border colour
        },
        {
          title: "Machine Learning",
          company: "Dataset: Student Records (Open University)",
          company_url: "https://faisaljina.github.io/machine-learning-ou/",
          logo_path: "scikitlearn.png",
          duration: "Features: EDA, Feature Engineering, Pipelines, Feature Importance, Visualisation",
          location: "Techniques: SMOTE, PowerTransformer, KNNImputer, Gradient Boosting, ElasticNet, Ridge/Lasso Regression",
          description:
            "Student data was used to predict course withdrawal and failure. After exploring, merging, and feature engineering, the dataset was cleaned, reduced, and outliers and colinearity addressed. The data was split into test and train sets, transformed, missing values imputed, and synthetic data generated for the minority target class. Both classification and regression approaches used pipelines, selecting appropriate metrics and cross-validating models, and confirming findings statistically. Feature importance was visualised and outcomes derived for the university.",
          color: "#000000", //border colour
        },
        {
          title: "Programming and Data Analysis",
          company: "Dataset: House Price Index",
          company_url: "https://faisaljina.github.io/prog-analysis-hpi/",
          logo_path: "pythonlogo.svg.png",
          duration: "Features: EDA, Preprocessing, Visualisation, Data Analysis",
          location: "Techniques: Function Writing, Error Handling, Memory Management, Statistics, Boxplots",
          description:
            "The House Price Index (HPI) dataset from gov.uk was explored. A function and dictionary were used to identify column names using the gov.uk definitions. New summary columns were created and the dataset reduced. 10-year trends were visualised in a scatterplot and interpreted. Short-term trends were examined using boxplots and probability density plots and outcomes discussed.",
          color: "#000000", //border colour
        },
      ],
    },
    {
      title: "R Projects",
      experiences: [
        // {
        //   title: "Associate AI Engineer",
        //   company: "Legato Health Technology",
        //   company_url: "https://legatohealthtech.com/",
        //   logo_path: "legato_logo.png",
        //   //duration: "June 2020 - PRESENT",
        //   location: "Hyderabad, Telangana",
        //   description:
        //     "I am working on automating healthcare products. The projects involve automation for process improvements and for significantly enhancing the profits. I am currently working on Cancer Survival and Reoccurence Prediction. Our goal is to make AI system which scales and removes doctor dependency as much as possible.",
        //   color: "#0879bf",
        // },
        {
          title: "Data Analytics and Dashboarding",
          company: "Dataset: House Price Index",
          company_url: "https://faisaljina.github.io/data-analytics-dashboard/",
          logo_path: "Shiny-logo.png",
          duration: "Features: EDA, Visualisation, Hypothesis Testing, Dashboarding",
          location: "Techniques: Linear Regression Modelling, Shapiro-Wilk Normality Testing, Welch 2-Sample T-Testing, RShiny",
          description:
            "Regional trends were compared graphically. The 10-year trend was modelled and statistically analysed, and a dashboarded graph created. Regional variation was examined using boxplots, which were dashboarded to enable realtime generation from selecting graph areas. Short-term trend differences were tested for normality, then t-tested for group difference. The significant difference found was visualised, dashboarded and discussed. RShiny Dashboard available at: https://faisaljina.shinyapps.io/dataanalyticsdashboard/",
          color: "#000000", //border colour
        },
        {
          title: "Time Series in Base R",
          company: "Dataset: Met Office UK Temperatures",
          company_url: "https://faisaljina.github.io/R-Time-Series-Met-Temperatures/",
          logo_path: "R_logo.svg.png",
          duration: "Features: Time Series Modelling, lapply, Trend/Seasonality/ARMA modelling, Forecasting",
          location: "Techniques: Time Series, Vectorisation, First Principles Trend & Seasonality Estimation, Visualisation, Statistical Analysis",
          description:
            "Met Office temperature data was loaded from gov.uk, creating 30 time series datasets. EDA was performed including visualisation. Trends were estimated using linear, quadratic and cubic models. Seasonality was estimated using seasonal means and sine-cosine order-6 models, checking for statistical significance. ARMA models were generated on the residuals up to (3,3). Forecasting was compared to a test set and accuracy metrics analysed.",
          color: "#000000", //border colour
        },
      ],
    },
  ],
};

// Projects Page
// THIS IS NOT USED - SEE EXPERIENCE SECTION TO UPDATE!!
const projectsHeader = {
  title: "Projects",
  description:
    "Blah blah",
  avatar_image_path: "projects_image.svg",
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "animated_ashutosh.png",
    description:
      "I am always keen to hear about new opportunities in Data Science, Finance, Business, or Healthcare. If you think my skillset might be what you're looking for, please get in touch!",
  },
  blogSection: {
    title: "Blogs",
    subtitle:
      ".",
    link: ".",
    avatar_image_path: "blogs_image.svg",
  },
  addressSection: {
    title: ".",
    subtitle:
      ".",
    avatar_image_path: "address_image.svg",
    location_map_link: ".",
  },
  phoneSection: {
    title: ".",
    subtitle: ".",
  },
};

export {
  settings,
  seo,
  greeting,
  socialMediaLinks,
  skills,
  competitiveSites,
  degrees,
  certifications,
  experience,
  projectsHeader,
  contactPageData,
};
